
import { ChallengeEdit } from './ChallengesEdit';

export default {
    edit: ChallengeEdit
};
